import { useToggle } from "../contexts/ToggleContext";

export function IfEnabled({ flag, children, fallback = null }) {
    const enabled = useToggle(flag);
    if (!enabled) return fallback;
    return children;
}
